import { cx } from '@emotion/css';
import type { FC, PropsWithChildren } from 'react';
import { useContext } from 'react';

import { dataSetToAttributes } from '../../utils';
import { PrimitivesContext } from '../Primitives';
import { itemCss, itemLinkActiveCss, itemLinkCss } from './styles';
import type { SubNavigationItemProps } from './types';

export const SubNavigationItem: FC<PropsWithChildren<SubNavigationItemProps>> = ({
  href,
  isActive,
  onLinkClick,
  className,
  children,
  dataset,
}) => {
  const { Anchor } = useContext(PrimitivesContext);

  return (
    <li className={cx(itemCss, className)} {...dataSetToAttributes(dataset)}>
      <Anchor
        className={cx(itemLinkCss, { [itemLinkActiveCss]: isActive })}
        href={href}
        onClick={onLinkClick}
      >
        {children}
      </Anchor>
    </li>
  );
};

SubNavigationItem.displayName = 'SubNavigationItem';
